import React from 'react';
import Header from './components/Header/Header';
import Shop from './components/Shop/Shop';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div>
      <Header></Header>
      <Shop></Shop>
      {/* <Footer></Footer> */}
    </div>
  );
}

export default App;
